  <template>
  <div class="skinnedmenu dropdown dropleft" style="position: relative; color: inherit;display:inline-table;">
    <a href="#" class="btn btn-link btn-light px-1" data-toggle="dropdown" data-boundary="viewport" id="headerlink" style="min-height: 36px; width: 100%; font-size: 12px !important;">
      <nobr>{{selValue}}</nobr>
    </a>
    <div class="skinnedmenu dropdown-menu dropdown-menu-left viewportfix pt-1" style="position:absolute;">
      <a v-for="(el, index) in getOptions()" @click="doChange(el)" href="#" class="dropdown-item" style=""><span v-if="el.text == null || el.text == ''">[{{el.id}}]</span><span v-if="el.text != null && el.text != ''">{{el.text}}</span><i v-if="el.id == selValue" class="icon-checkmark2 ml-1"></i></a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'input-select3',
    components: {
    },
    data() {
      return {
        array: [],
        selValue: ''
      };
    },
    props: {
      value: {
        required: false,
        type: String,
        default: null
      },
      options: {
        required: false,
        type: Array,
        default() {
          return []
        }
      },
      idcolumnname: {
        required: false,
        type: String,
        default: null
      },
      textcolumnname: {
        required: false,
        type: String,
        default: null
      },
    },
    methods: {
      doChange(el) {
        this.value = el.id;
        this.selected = el.id;
        this.$emit("changed", el);
      },
      getId() {
        return this._uid;
      },
      realValue() {
        return this.array;
      },
      getOptions() {
        var arr = [];
        var selectedValue = "";
        if (this.idcolumnname != null && this.textcolumnname != null) {
          for (var i = 0; i < this.options.length; i++) {
            arr.push({ id: (this.options[i][this.idcolumnname]).toString(), text: this.shortenName(this.options[i][this.textcolumnname]) });
            if (arr[i].id == this.value) {
              selectedValue = arr[i].text;
            }
          }
        }
        else {
          for (var i = 0; i < this.options.length; i++) {
            arr.push({ id: this.options[i].toString(), text: this.shortenName(this.options[i]) });
            if (arr[i].id == this.value) {
              selectedValue = arr[i].text;
            }
          }
        }

        if (selectedValue == "" && this.value != null)
          selectedValue = this.value;
        if (selectedValue != null && selectedValue.length > 10) {
          selectedValue = selectedValue.substring(0, 7) + "...";
        }

        this.selValue = selectedValue;
        this.array = arr;
        Vue.set(this, "array", arr);
        return arr;
      },
      valueText() {
        var retVal = "";
        for (var i = 0; i < this.array.length; i++) {
          if (this.array[i].id === this.value) {
            retVal = this.array[i].text;
          }
        }
        if (retVal == "" && this.value != null)
          retVal = this.value;
        if (retVal.length > 10) {
          retVal = retVal.substring(0, 7) + ".";
        }
        return retVal;
      },
      shortenName(name) {
        if (name == null)
          return null;
        if (name.length > 25)
          name = name.substring(0, 22) + "...";
        return name;
      }
    },
    created() {

    },
    mounted() {

    },
    computed: {
     
      selected: {
        get() { return this.value },
        set(v) { this.$emit('input', v) }
      }
     
    },
    watch: {
      value: function (newVal, oldVal) {
        this.$forceUpdate();
      },
      options: function (newVal, oldVal) {
        var arr = [];
        if (this.idcolumnname != null && this.textcolumnname != null) {
          for (var i = 0; i < newVal.length; i++) {
            arr.push({ id: (newVal[i][this.idcolumnname]).toString(), text: this.shortenName(newVal[i][this.textcolumnname]) });
          }
        }
        else {
          for (var i = 0; i < newVal.length; i++) {
            arr.push({ id: newVal[i].toString(), text: this.shortenName(newVal[i]) });
          }
        }
        this.array = arr;
        Vue.set(this, "array", arr);
        this.$forceUpdate();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/form-components/input-select3.vue